const Platforms = require('config/platforms').default
const Models = require('models')

const Constants = require('api-constants').default
const VoltError = require('VoltError').default
const AbstractApi = require('../Api').default
// ----- REAL APIs -----
const StarhubApi = require('services/starhub').default
const ProxySearchApi = require('services/proxy/SearchApi').default
const PinApi = require('services/starhub/PinApi').default
const RecoApi = require('services/nagra/RecoApi').default
const MostWatchedApi = require('services/nagra/MostWatchedApi').default
const GatewayApi = require('services/ufinity/GatewayApi').default
// ----- STUBs -----
const ConfigurationApi = require('services/starhub/ConfigurationApi').default
class VoltApi extends AbstractApi {
    constructor(config) {
        super(config)
        this.searchApi = new ProxySearchApi(this.config, {
            metaApi: this.metaApi,
            commonApi: this.commonApi,
        })
        this.gatewayApi = new GatewayApi(this.config)
        this.pinApi = new PinApi(this.config, {
            gatewayApi: this.gatewayApi,
        })
        this.platformApi = new StarhubApi(this.config, {
            metaApi: this.metaApi,
            searchApi: this.searchApi,
            pinApi: this.pinApi,
            gatewayApi: this.gatewayApi,
            commonApi: this.commonApi,
        })
        this.recoApi = new RecoApi(this.config)
        this.mostWatchedApi = new MostWatchedApi(this.config)
    }
}

module.exports = {
    PLATFORM_NAME: Platforms.STARHUB,
    VoltApi,
    ConfigurationApi,
    Models,
    Constants,
    /** Starhub use only ParentalPin type and R21 type
     * NOTICE: it can provide an error in a sandbox
     * because of two same values in MASTER and ADULT but it is not a problem
     */
    PIN_TYPE: {
        MASTER: PinApi.TYPE.ADULT,
        ADULT: PinApi.TYPE.ADULT,
        CENSORSHIP: PinApi.TYPE.CENSORSHIP,
    },
    PIN_SIZE: 6,
    OTP_SIZE: 6,
    VoltError,
}
